import { render } from "./FacetsKpi.vue?vue&type=template&id=44966b82"
import script from "./FacetsKpi.vue?vue&type=script&lang=js"
export * from "./FacetsKpi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__